<ng-container>
    <p-card>
        <p-menu [model]="items" [style]="{'border': '0px','font-size': '11px', 'padding': '0px' }"></p-menu>   
    </p-card>
</ng-container>